/* ============================================================
   OooWee Deals — Custom theme runtime (extends Dawn)
   Loaded via theme.liquid <script defer>.
   ============================================================ */
(function(){
  const $  = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));

  // Klaviyo subscribe helper — keys live in oooweedeals-config.js (asset file).
  function subscribe(email, opts){
    const cfg = window.OW_CONFIG || {};
    const key = cfg.KLAVIYO_PUBLIC_KEY;
    const listId = (opts && opts.list) || cfg.KLAVIYO_LIST_MEMBERS;
    const source = (opts && opts.source) || "shopify";
    const properties = Object.assign({"$source":"OooWee shopify — "+source}, (opts&&opts.properties)||{});
    if (!key || !listId || !email) return Promise.resolve(true);
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+encodeURIComponent(key),{
      method:"POST", mode:"cors",
      headers:{"Content-Type":"application/json","revision":"2024-10-15"},
      body: JSON.stringify({data:{type:"subscription",attributes:{custom_source:source,profile:{data:{type:"profile",attributes:{email,properties}}}},relationships:{list:{data:{type:"list",id:listId}}}}})
    }).then(r=>r.ok||r.status===202).catch(()=>false);
  }
  document.addEventListener("submit", function(e){
    const f = e.target.closest("form[data-ow-subscribe]"); if (!f) return;
    const email = (f.querySelector('input[type="email"]')||{}).value || "";
    const source = f.getAttribute("data-ow-subscribe") || "shopify";
    const list = f.getAttribute("data-ow-list") || (window.OW_CONFIG||{}).KLAVIYO_LIST_MEMBERS;
    subscribe(email, {source, list});
  }, true);

  function initHero(){
    const root = $(".ow-hero-track");
    if(!root) return;
    const slides = $$(".ow-hero-slide", root);
    const dots = $(".ow-hero-dots", root);
    if(!slides.length || !dots) return;
    dots.innerHTML = "";
    slides.forEach((s,i)=>{
      const b=document.createElement("button");
      b.setAttribute("aria-label",`Slide ${i+1}`);
      if(i===0) b.classList.add("is-active");
      b.addEventListener("click",()=>setSlide(i));
      dots.appendChild(b);
    });
    let idx=0;
    function setSlide(i){
      slides.forEach((s,j)=>s.classList.toggle("is-active",j===i));
      $$("button",dots).forEach((b,j)=>b.classList.toggle("is-active",j===i));
      idx=i;
    }
    setInterval(()=>setSlide((idx+1)%slides.length), 5500);
  }

  function tickCountdown(){
    const h=$("#owCdH"),m=$("#owCdM"),s=$("#owCdS");
    if(!h) return;
    const now=new Date();
    const end=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1,0,0,0);
    let sec=Math.max(0,Math.floor((end-now)/1000));
    h.textContent=String(Math.floor(sec/3600)).padStart(2,"0");
    m.textContent=String(Math.floor((sec%3600)/60)).padStart(2,"0");
    s.textContent=String(sec%60).padStart(2,"0");
  }

  const RKEY="ow_recent_v1";
  function getRecent(){try{return JSON.parse(localStorage.getItem(RKEY)||"[]")}catch(e){return[]}}
  function pushRecent(p){
    let r=getRecent().filter(i=>i.handle!==p.handle);
    r.unshift(p); r=r.slice(0,12);
    localStorage.setItem(RKEY,JSON.stringify(r));
    renderRecent();
  }
  function clearRecent(){localStorage.removeItem(RKEY);renderRecent();}
  function recentCardHTML(p){
    return `<a class="ow-card" href="${p.url}">
      <div class="ow-card-img"><img src="${p.img}" alt="" loading="lazy"></div>
      <div class="ow-card-body">
        <div class="ow-card-title">${p.title}</div>
        <div class="ow-card-price"><b>${p.price}</b></div>
      </div>
    </a>`;
  }
  function renderRecent(){
    const rail=$("#owRecentRail");
    if(!rail) return;
    const items=getRecent();
    rail.innerHTML = items.length
      ? items.map(recentCardHTML).join("")
      : `<div style="padding:12px 16px;color:#6B7280;font-size:13px;">Tap any product — we'll keep your last 12 here.</div>`;
  }
  document.addEventListener("click",(e)=>{
    const a=e.target.closest('a[href*="/products/"]');
    if(!a) return;
    const card=a.closest(".ow-card");
    if(!card) return;
    pushRecent({
      handle:a.getAttribute("href"),
      title:card.dataset.title || card.querySelector(".ow-card-title")?.textContent.trim() || "Product",
      price:card.dataset.price || card.querySelector(".ow-card-price b")?.textContent.trim() || "",
      img:card.dataset.img || card.querySelector("img")?.src || "",
      url:a.getAttribute("href")
    });
  });

  document.addEventListener("click",(e)=>{
    const btn = e.target.closest(".ow-card-add");
    if(!btn || !btn.dataset.variantId) return;
    e.preventDefault(); e.stopPropagation();
    btn.disabled = true; const original = btn.textContent; btn.textContent = "Adding…";
    fetch("/cart/add.js",{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({items:[{id:Number(btn.dataset.variantId),quantity:1}]})
    }).then(r=>r.json()).then(()=>{
      btn.textContent="Added ✓";
      btn.style.background="var(--ow-blue)";
      fetch("/cart.js").then(r=>r.json()).then(c=>{
        const b=document.querySelector(".cart-count-bubble span[aria-hidden]");
        if(b) b.textContent=c.item_count;
        document.dispatchEvent(new CustomEvent("ow:cart:updated",{detail:c}));
      });
      setTimeout(()=>{btn.textContent=original;btn.style.background="";btn.disabled=false},1600);
    }).catch(()=>{btn.textContent="Try again";btn.disabled=false});
  });

  const PRIZES=[
    {label:"10% OFF",code:"SPIN10",weight:30},
    {label:"FREE SHIP",code:"SHIPFREE",weight:18},
    {label:"15% OFF",code:"SPIN15",weight:18},
    {label:"5% OFF",code:"SPIN5",weight:14},
    {label:"FREE GIFT",code:"GIFT2U",weight:8},
    {label:"20% OFF",code:"SPIN20",weight:8},
    {label:"30% OFF",code:"BIGSPIN30",weight:3},
    {label:"TRY AGAIN",code:"",weight:1}
  ];
  const OW_WHEEL_COLORS=['#F58634','#1F7DEF','#FFC93C','#F58634','#1F7DEF','#FFC93C','#F58634','#1F7DEF'];
  function placeWheelLabels(){
    const wheel=$("#owWheel"); if(!wheel) return;
    const stale=$("#owWheelLabels"); if(stale) stale.remove();
    const VB=280, cx=VB/2, cy=VB/2, R=VB/2, TR=95, PAD=2;
    function polar(rad,deg){const r=deg*Math.PI/180;return{x:cx+rad*Math.sin(r),y:cy-rad*Math.cos(r)};}
    function slicePath(s,e){const a=polar(R,s),b=polar(R,e);return`M${cx} ${cy}L${a.x.toFixed(2)} ${a.y.toFixed(2)}A${R} ${R} 0 0 1 ${b.x.toFixed(2)} ${b.y.toFixed(2)}Z`;}
    function arcPath(s,e,sw){const a=polar(TR,s),b=polar(TR,e);return`M${a.x.toFixed(2)} ${a.y.toFixed(2)}A${TR} ${TR} 0 0 ${sw} ${b.x.toFixed(2)} ${b.y.toFixed(2)}`;}
    let defs='',slices='',labels='';
    PRIZES.forEach((p,i)=>{
      const s=i*45-45, e=i*45, c=i*45-22.5;
      const norm=((c%360)+360)%360, isBottom=norm>90&&norm<270;
      slices+=`<path d="${slicePath(s,e)}" fill="${OW_WHEEL_COLORS[i]}"/>`;
      const aS=isBottom?e-PAD:s+PAD, aE=isBottom?s+PAD:e-PAD, sw=isBottom?0:1;
      defs+=`<path id="owArc${i}" d="${arcPath(aS,aE,sw)}" fill="none"/>`;
      labels+=`<text font-size="12" fill="#fff" font-family="ui-sans-serif,system-ui,sans-serif" font-weight="900" text-anchor="middle" dominant-baseline="middle" letter-spacing="0.3" style="text-shadow:0 1px 2px rgba(0,0,0,.45)"><textPath href="#owArc${i}" startOffset="50%">${p.label}</textPath></text>`;
    });
    wheel.innerHTML=`<svg viewBox="0 0 ${VB} ${VB}" xmlns="http://www.w3.org/2000/svg"><defs>${defs}</defs>${slices}${labels}</svg>`;
    wheel.style.background='#1A1A1A';
    wheel.style.overflow='hidden';
  }
  function pickPrize(){
    const total=PRIZES.reduce((a,p)=>a+p.weight,0);
    let r=Math.random()*total;
    for(let i=0;i<PRIZES.length;i++){r-=PRIZES[i].weight;if(r<=0) return i}
    return 0;
  }
  function celebrate(){
    const host=$("#owConfetti"); if(!host) return;
    const colors=["#F58634","#1F7DEF","#FFC93C","#1A1A1A","#fff"];
    for(let i=0;i<50;i++){
      const c=document.createElement("div");
      Object.assign(c.style,{position:"fixed",top:"-12px",left:Math.random()*100+"vw",width:"8px",height:"14px",background:colors[i%5],transform:`rotate(${Math.random()*360}deg)`,transition:`transform 1.6s ease, top 1.6s ease, opacity .6s`,opacity:1,borderRadius:"2px",zIndex:97});
      host.appendChild(c);
      requestAnimationFrame(()=>{c.style.top=(60+Math.random()*40)+"vh";c.style.transform=`translateX(${Math.random()*200-100}px) rotate(${Math.random()*720}deg)`});
      setTimeout(()=>{c.style.opacity=0;setTimeout(()=>c.remove(),700)},1800);
    }
  }
  function initSpin(){
    const fab=$("#owSpinFab"), modal=$("#owSpinModal"), form=$("#owSpinForm");
    if(!fab || !modal) return;
    placeWheelLabels();
    const open=()=>modal.classList.add("is-open");
    const close=()=>modal.classList.remove("is-open");
    fab.addEventListener("click",open);
    $$("[data-ow-close]",modal).forEach(el=>el.addEventListener("click",close));
    let spinning=false, total=0;
    form && form.addEventListener("submit",(e)=>{
      e.preventDefault(); if(spinning) return; spinning=true;
      const btn=$("#owSpinBtn"); btn.disabled=true; btn.textContent="Spinning…";
      const sEmail = ($("#owSpinEmail")||{}).value || "";
      const sCfg = window.OW_CONFIG || {};
      subscribe(sEmail, {
        list: sCfg.KLAVIYO_LIST_SPIN || sCfg.KLAVIYO_LIST_MEMBERS,
        source: "spin-to-win",
        properties: {"opt_in_via":"spin-to-win"}
      });
      const i=pickPrize();
      const desired=(22.5 - i*45 + 360) % 360;
      const cur=((total%360)+360)%360;
      const delta=(desired - cur + 360) % 360;
      total+=360*5+delta;
      $("#owWheel").style.transform=`rotate(${total}deg)`;
      setTimeout(()=>{
        const p=PRIZES[i]; const win=$("#owWinMsg");
        if(p.code){
          $("#owWinTitle").textContent=`🎉 You won ${p.label}!`;
          $("#owWinCode").textContent=p.code; celebrate();
        } else {
          $("#owWinTitle").textContent="Almost! Try tomorrow."; $("#owWinCode").textContent="—";
        }
        win.classList.add("is-show");
        btn.textContent=p.code?"Copy code":"Maybe next time";
        btn.disabled=false; spinning=false;
        btn.onclick=(ev)=>{ev.preventDefault();if(p.code){navigator.clipboard?.writeText(p.code);btn.textContent="Copied ✓"}};
      },4700);
    });
    if(!localStorage.getItem("ow_spin_seen")){
      setTimeout(()=>{open();localStorage.setItem("ow_spin_seen","1")},8000);
    }
  }

  document.addEventListener("DOMContentLoaded",()=>{
    initHero();
    setInterval(tickCountdown,1000); tickCountdown();
    renderRecent();
    initSpin();
  });

  window.OW = { clearRecent };
})();
